export default {
    listagem: {
        titulo_pagina: 'Lista de Materiais',
        novo: 'Criar novo Material',
        habilitado: 'Habilitado',
        desabilitado: 'Desabilitado',
        table: {
            empty: 'Nenhum Material encontrado',
            nome: 'Nome',
            codigo: 'Código',
            editar: 'Editar'
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Criar novo Material',
            editar: 'Editar Material'
        },
        fields: {
            codigo: {
                label: 'Código',
                description: 'Código do Material'
            },
            nome: {
                label: 'Nome',
                description: 'Nome do Material'
            },
            status: {
                label: 'Status',
                description: 'Status ativo ou inativo do Material'
            },
            botao_salvar : 'Salvar Material'
        },
        create: {
            success: 'Material criado com Sucesso!',
            error: 'Error ao criar Material!'
        },
        update: {
            success: 'Material editado com Sucesso!',
            error: 'Error ao editar Material!'
        }
    }
}
